import { redirect } from 'next/navigation';

export default function PlatformMasterIndex() {
  redirect('/platform-master/customers');
}
